/* eslint-disable jsx-a11y/label-has-associated-control */
import ContentBlocks from 'app/components/content-blocks/index';
import FilterDropdown from 'app/components/partials/category-search/filter-dropdown';
import Icon from 'app/components/partials/icon';
import PageHeader from 'app/components/partials/page-header';
import PropTypes from 'prop-types';
import React from 'react';
import { useFormik } from 'formik';
import WhatsOnEvent from 'app/components/partials/custom-page/whats-on-event';
import WhatsOnExhibition from 'app/components/partials/custom-page/whats-on-exhibition';
import { EVENT_DATE_FILTER, EXHIBITION_DATE_FILTER } from 'config/search-options';
import { useNavigate, useParams } from 'react-router-dom';

const REFERENCE_TYPE = {
    options: [
        { label: 'Events', value: 'events' },
        { label: 'Exhibitions', value: 'exhibitions' }
    ],
    defaultIndex: 0,
};

const WhatsOn = ({ data }) => {
    const {
        dateRange = 'today',
        eventType = 'events',
        searchKeyword = '',
    } = useParams();

    const {
        blocks,
        title,
        header_image: images,
        subtitle: subTitle,
        background_color: backgroundColor,
    } = data;

    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            reference: eventType,
            keywords: searchKeyword,
            'date-range': dateRange,
        },
        onSubmit: async(values) => {
            const params = new URLSearchParams({
                'date-range': values['date-range'],
            });
            // Only set keywords if not empty
            if (values.keywords) {
                params.set('keywords', values.keywords);
            }
            navigate(`/search/${values.reference}?${params}`);
        }
    });

    const renderWhatsOnSearchForm = (formik) => {
        return (
            <form className="whats-on-search-form || search-bar || constrain-width" onSubmit={formik.handleSubmit}>
                <div className="field-group grow">
                    <label htmlFor="search-query" className="label search"><Icon name="search" width="24" height="24" /></label>
                    <input className="input" id="search-query" type="text" name="keywords" value={formik.values.keywords} onChange={formik.handleChange} placeholder="Search for..." autoComplete="off" />
                </div>
                <div className="field-group shrink no-padding reference-filter">
                    <FilterDropdown className="reference-type" filterName="reference" filterOptions={REFERENCE_TYPE.options} filterLable="Reference" defaultOptionIndex={REFERENCE_TYPE.defaultIndex} formik={formik} clickToSubmit={false} value={formik.values.reference} />
                </div>
                <div className="field-group shrink no-padding date-range-filter">
                    <FilterDropdown className="date-range" filterName="date-range" filterOptions={formik.values.reference === 'exhibitions' ? EXHIBITION_DATE_FILTER.options : EVENT_DATE_FILTER.options} filterLable="event dates" defaultOptionIndex={formik.values.reference === 'exhibitions' ? EXHIBITION_DATE_FILTER.defaultIndex : EVENT_DATE_FILTER.defaultIndex} formik={formik} clickToSubmit={false} value={formik.values['date-range']} />
                </div>
                <div className="field-group shrink">
                    <button className="button primary small" type="submit">SEARCH</button>
                </div>
            </form>
        );
    };

    return (
        <div className="whats-on-page">
            <PageHeader
                image={images}
                subTitle={subTitle}
                title={title}
                backgroundColor={backgroundColor}
            />
            <ContentBlocks data={blocks} pageTitle={title} extraClass="constrain-width" />
            {renderWhatsOnSearchForm(formik)}
            <WhatsOnEvent />
            <WhatsOnExhibition />
        </div>
    );
};

WhatsOn.propTypes = {
    data: PropTypes.object.isRequired
};

export default WhatsOn;
